import React, { useState, useEffect } from "react";
import { Typography, IconButton } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateAccount from "./CreateAccount";
import useWindowDimensions from "../../../useWindowDimensions";
import UseFetchData from "../../../hooks/UseFetchData";

const AccountViewHeader = ({ AccountID, AccountMainData, getViewDtlsData, PopulateData }) => {
  const classes = useStyles();
  const { height, width } = useWindowDimensions();
  const [isOpen, setOpen] = useState(false);
  const [accountID, setaccountID] = useState("");
  const [Industry, setIndustry] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [AccountCode, setAccountCode] = useState("");
  const [NoOfEmployees, setNoOfEmployees] = useState("");
  const [BillAddress, setBillAddress] = useState("");
  const [BillCountry, setBillCountry] = useState("");
  const [BillState, setBillState] = useState("");
  const [BillCity, setBillCity] = useState("");
  const [BillPINCode, setBillPINCode] = useState("");
  const [ShipAddress, setShipAddress] = useState("");
  const [ShipCity, setShipCity] = useState("");
  const [ShipPINCode, setShipPINCode] = useState("");
  const [ShipCountry, setShipCountry] = useState("");
  const [ShipState, setShipState] = useState("");
  const [WebSite, setWebSite] = useState("");
  const [Phone, setPhone] = useState("");
  const [Description, setDescription] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  // 10-feb- Change
  const [cmbAccTypeData, setcmbAccTypeData] = useState([]);
  const [cmbAccGroupData, setCmbAccGroupData] = useState([]);
  const [cmbIndustryData, setcmbIndustryData] = useState([]);
  const [cmbCurrencyData, setcmbCurrencyData] = useState([]);
  const [cmbCountryData, setcmbCountryData] = useState([]);
  const [ComboDataResponse, fetchComboData] = UseFetchData();


  const handleOpenModal = () => {
    setaccountID(AccountID);
    setOpen(true);
  };

  const OpenModal = () => {
    setaccountID("");
    setOpen(true);
  };

  useEffect(() => {
    // 10-feb- Change
    GetComboData();
  }, []);

  const GetComboData = () => {
    // 10-feb- Change
    fetchComboData("SalesOrder/ComboDataHeader");
  };

  useEffect(() => {
    // 10-feb- Change
    //// debugger;
    if (ComboDataResponse !== undefined) {
      if (ComboDataResponse["AccountType"] !== undefined
        && ComboDataResponse["AccountGroup"] !== undefined
        && ComboDataResponse["Industry"] !== undefined
        && ComboDataResponse["Currency"] !== undefined
        && ComboDataResponse["Country"] !== undefined
      ) {
        setcmbAccTypeData(ComboDataResponse["AccountType"]);
        setCmbAccGroupData(ComboDataResponse["AccountGroup"]);
        setcmbIndustryData(ComboDataResponse["Industry"]);
        setcmbCurrencyData(ComboDataResponse["Currency"]);
        setcmbCountryData(ComboDataResponse["Country"]);

        // if (props.AccountID !== '') {
        //   BillStatecmbData("")
        //   ShipStatecmbData("")
        //   setMode('Update');
        //   GetAccountData();
        // }
        // else {
        // setMode('Insert');
        // }
      }
    }
  }, [ComboDataResponse]);


  useEffect(() => {
    if (AccountMainData !== undefined && AccountMainData.length > 0) {
      setAccountName(AccountMainData[0].AccountName);
      setAccountCode(AccountMainData[0].AccountCode);
      setWebSite(AccountMainData[0].WebSite);
      setPhone(AccountMainData[0].Phone);
      setNoOfEmployees(AccountMainData[0].NoOfEmployees);
      setDescription(AccountMainData[0].Description);
      setIndustry(AccountMainData[0].Industry);
      var BillAdd1 = AccountMainData[0].BillAddress1 === null ? "" : AccountMainData[0].BillAddress1;
      var BillAdd2 = AccountMainData[0].BillAddress2 === null ? "" : AccountMainData[0].BillAddress2;
      var ShipAdd1 = AccountMainData[0].ShipAddress1 === null ? "" : AccountMainData[0].ShipAddress1;
      var ShipAdd2 = AccountMainData[0].ShipAddress2 === null ? "" : AccountMainData[0].ShipAddress2;
      setBillAddress(BillAdd1 + " " + BillAdd2);
      setBillCity(AccountMainData[0].BillCity === null ? "" : AccountMainData[0].BillCity)
      setBillState(AccountMainData[0].BillState === null ? "" : AccountMainData[0].BillState);
      setBillCountry(AccountMainData[0].BillCountry === null ? "" : AccountMainData[0].BillCountry);
      setBillPINCode(AccountMainData[0].BillPINCode === null ? "" : AccountMainData[0].BillPINCode);
      setShipAddress(ShipAdd1 + " " + ShipAdd2);
      setShipCity(AccountMainData[0].ShipCity === null ? "" : AccountMainData[0].ShipCity)
      setShipState(AccountMainData[0].ShipState === null ? "" : AccountMainData[0].ShipState);
      setShipCountry(AccountMainData[0].ShipCountry === null ? "" : AccountMainData[0].ShipCountry);
      setShipPINCode(AccountMainData[0].ShipPINCode === null ? "" : AccountMainData[0].ShipPINCode);
      setCreatedBy(AccountMainData[0].CreatedBy);
    }
  }, [AccountMainData]);



  return (
    <div>
      <Typography
        className={classes.headertext}
        noWrap
        component={"span"}
        variant={"body2"}
      >
        <AccountBoxIcon style={{ fontSize: 45 }} />
        <div style={{ flexDirection: "column" }}>
          <div style={{ fontSize: 13, marginTop: 4 }}>Account</div>
          <div style={{ fontSize: 19, marginTop: -4, fontWeight: "bold" }}>
            {AccountName}
          </div>
        </div>
        {width > 600 &&
          <div style={{ width: "100%" }}>
            <div style={{ float: "right", marginTop: -3 }}>
              <BiztranControls.Button
                text="Add"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  OpenModal();
                }}
              />
              <BiztranControls.Button
                text="EDIT"
                startIcon={<EditIcon />}
                onClick={() => {
                  handleOpenModal();
                }}
              />
            </div>
          </div>
        }
        {width < 600 &&
          <div style={{ width: "100%" }}>
            <div style={{ float: "right", marginTop: -12 }}>
              <IconButton onClick={() => { OpenModal() }}>
                <AddCircleOutlineIcon />
              </IconButton>
              <IconButton onClick={() => { handleOpenModal() }}>
                <EditIcon />
              </IconButton>
            </div>
          </div>
        }
      </Typography>
      <Grid spacing={1} container style={{ marginTop: 7, paddingLeft: 10 }}>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Account Name:</h5>
            <h5 style={{ color: "#0096FF" }}>{AccountName}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Account Code:</h5>
            <h5 style={{ color: "#0096FF" }}>{AccountCode}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Website:</h5>
            <h5 style={{ color: "#0096FF" }}>{WebSite}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Account Owner:</h5>
            <h5 style={{ color: "#0096FF" }}>{CreatedBy}</h5>
          </Grid>
        </Grid>

        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Phone No:</h5>
            <h5 style={{ color: "#0096FF" }}>{Phone}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Description:</h5>
            <h5 style={{ color: "#0096FF" }}>{Description}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Industry:</h5>
            <h5 style={{ color: "#0096FF" }}>{Industry}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Employees:</h5>
            <h5 style={{ color: "#0096FF" }}>{NoOfEmployees}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Billing Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{BillAddress + " " + BillCity}</h5>
            <Grid item md={5} container direction="row">
              <h5 style={{ width: 110, color: "#0096FF" }}>{BillState + " " + BillCountry + " " + BillPINCode}</h5></Grid>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Shipping Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{ShipAddress + " " + ShipCity}</h5>
            <Grid item md={5} container direction="row">
              <h5 style={{ width: 110, color: "#0096FF" }}>{ShipState + " " + ShipCountry + " " + ShipPINCode}</h5></Grid>
          </Grid>
        </Grid>
      </Grid>
      <ModalFrame
        title="Account Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateAccount
          //10-feb-change
          AccountID={accountID}
          setOpen={setOpen}
          // getByIDData={getViewDtlsData}
          AccountMainData={AccountMainData}
          PopulateData={PopulateData}

        />
      </ModalFrame>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.2rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
    //   borderRadius: "1rem",
  },
}));

export default AccountViewHeader;
